import React from "react";

type RealEstateToggleProps = {
  checked: boolean;
  onChange: (checked: boolean) => void;
  onLabel?: string;
  offLabel?: string;
  disabled?: boolean;
};

export function RealEstateToggle({
  checked,
  onChange,
  onLabel = "On",
  offLabel = "Off",
  disabled = false,
}: RealEstateToggleProps): React.ReactElement {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={checked ? onLabel : offLabel}
      className={`re-toggle${checked ? " is-on" : ""}`}
      disabled={disabled}
      onClick={() => onChange(!checked)}
    >
      <span className="re-toggle-track" aria-hidden="true">
        <span className="re-toggle-thumb" />
      </span>
      <span className="re-toggle-copy">{checked ? onLabel : offLabel}</span>
    </button>
  );
}
